import { render, staticRenderFns } from "./promptChip.vue?vue&type=template&id=329eb9da&scoped=true&"
import script from "./promptChip.vue?vue&type=script&lang=js&"
export * from "./promptChip.vue?vue&type=script&lang=js&"
import style0 from "./promptChip.vue?vue&type=style&index=0&id=329eb9da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329eb9da",
  null
  
)

export default component.exports